module.exports = flarum.reg.get('fof-upload', 'forum');